module.exports = "## Tabs\n\n[Tabs](https://www.google.com/design/spec/components/tabs.html) make it easy to explore and switch between different views or functional aspects of an app or to browse categorized data sets.\n\nTabs can operate in two different modes: controlled and uncontrolled.\n- The uncontrolled mode takes over automatically if no value prop is passed to your\nTabs and Tab components.\n- If you want controllable tabs, passing a value to both the Tabs and Tab elements\nwill let you programmatically adjust which one is selected.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Tabs/README.md
 ** module id = 1077
 ** module chunks = 0
 **/